 
<template> 
    <CardRh :processando="processando" titulo="Atualizar" >   
        <div class="modal-body scroll-y m-5 div-body-card-form"  >
            <div class="row g-6 g-xl-12"   >  
                <ListaCampoForm :campos="campos" :formulario="formulario"   ></ListaCampoForm>  
            </div>  
        </div>  
        <div class="modal-footer"  > 
            <BotaoSalvar  @click="salvar" :processando="processando" titulo="Atualizar"></BotaoSalvar>   
        </div> 
    </CardRh>  
</template>

<script lang="ts">
	  
    import BotaoSalvar from '@/components/aplicacao/BotaoSalvar.vue';
    import ListaCampoForm from '@/components/aplicacao/ListaCampoForm.vue'; 
    import { Options, Vue  } from "vue-class-component";  
    import   SiteUtils   from '@/assets/ts/aplicacao/site';
    import {  Prop  , Watch } from 'vue-property-decorator';   
    import CardRh from   "@/components/cards/ManzaCard.vue"
	import { namespace } from 'vuex-class'; 
    const authStore = namespace('auth'); 


    @Options({
        name: "ModeloUpdatePagina",
        components: {  ListaCampoForm, BotaoSalvar, CardRh },   
    }) 
    export default class ModeloUpdatePagina extends Vue {
  
        @authStore.Getter
		public perfis!: any  
 
        public service: any = null
        public modelo: any= null
         
        public processando = false;  
        public formulario: any  = { } ;  
        public campos: Array<any> = [ ];
 
        public modeloAlterado(){  
            console.log('atualizando');
        }

        @Watch('modelo')
		modeloAtualizada(newVal: string) { 
            this.modeloAlterado(); 
		}
 
        get hasPermissao(   ): boolean {
            return false; 
        }
    
        public sucesso(){  
            console.log('sucesso');
        }
 
        public getdados(){  
            let dados = JSON.parse(JSON.stringify(this.formulario)); 
            return dados;
        }

        public salvar(){
            if( this.processando  ||  !this.hasPermissao ){
                return;
            }
            this.processando = true ;  
            let dados = this.getdados() ;  
            setTimeout(() => {  
                this.service.update(  this.modelo.id, dados )
                .then(response => { 
                    SiteUtils.toastSucesso('Atualizado com sucesso! ' ,  response.message  );
                    this.sucesso();  
                    this.formulario = {};
                    this.processando = false ;  
                }) 
                .catch(error => {
                    this.processando = false ;
                    SiteUtils.toastErro('Error! ' ,  error.data.message  );
                });  
            }, 100); 
        }  
    }    
</script>
 
<style scoped> 
    .btn-sm{
        margin-left: 10px; 
    }
    .registro-alteracao{
        text-align: right;
    }

    .div-body-card-form{
        padding-bottom: 120px !important;
    }

</style>